import { Component, OnInit } from '@angular/core';
import { IGenericCrudConfiguration } from '../../../../libs/components/generic-crud/generic-crud.component';
import { DraftableStateTypes, WorkProcedure } from '../../../../models';
import { MasterApiService } from '../../../../services/master-api.service';
import { WorkProceduresAddComponent } from './work-procedures-add/work-procedures-add.component';
import { WorkProceduresEditComponent } from './work-procedures-edit/work-procedures-edit.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-work-procedures',
    templateUrl: './work-procedures.component.html',
    styleUrl: './work-procedures.component.sass',
    standalone: false
})
export class WorkProceduresComponent implements OnInit {
  config?: IGenericCrudConfiguration<WorkProcedure>;

  constructor(private api: MasterApiService, private translateService: TranslateService) {}

  async ngOnInit(): Promise<void> {
      const stateTypes = DraftableStateTypes.map(x => ({ id: x.id, name: this.translateService.instant(`enumeration.DraftableStateTypes.${x.name}`) }));

      this.config = {
      name: this.api.resources.product.workProcedures.resourceName,
      resource: this.api.resources.product.workProcedures,
      createComponent: WorkProceduresAddComponent,
      editComponent: {component: WorkProceduresEditComponent, inputPrms:{genericInfoAlternativeText: 'common.tabTitle.workProcedure'}},
      entityFields: {
        code: { isLink: true, caption: 'common.code' },
        name: { isLink: true, caption: 'common.name' },
        stateId: {
          caption: 'common.state',
          dataType: 'number',
          cellTemplate: 'stateCellTpl',
          lookup: {
            dataSource: stateTypes,
            displayExpr: 'name',
            valueExpr: 'id',
          },
        },
        version: { caption: 'common.version' },
      },
      crudButtons: {
        canCopy: true,
      },
    }
  }

}
